/**
 * @private
 */
export const convertChatMessage = (message, status = 'delivered', clientMessageId) => {
    return Object.assign(Object.assign({}, message), { clientMessageId: clientMessageId, status });
};
//# sourceMappingURL=convertChatMessage.js.map